import React from 'react';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2>{t('contact.get_in_touch')}</h2>
              <p>{t('contact.description')}</p>
              
              <h3>{t('contact.contact_info_title')}</h3>
              <div style={{ marginBottom: '2rem' }}>
                <p><strong>📧 {t('contact.email')}:</strong> info@molecorp.club</p>
                <p><strong>🌐 {t('contact.website')}:</strong> www.molecorp.club</p>
              </div>

              <h3>{t('contact.response_times')}</h3>
              <ul>
                <li><strong>{t('contact.email_queries')}</strong></li>
                <li><strong>{t('contact.project_quotes')}</strong></li>
                <li><strong>{t('contact.emergency_support')}</strong></li>
              </ul>

              <h3>{t('contact.what_to_include')}</h3>
              <ul>
                <li>{t('contact.include_item_1')}</li>
                <li>{t('contact.include_item_2')}</li>
                <li>{t('contact.include_item_3')}</li>
                <li>{t('contact.include_item_4')}</li>
                <li>{t('contact.include_item_5')}</li>
              </ul>
            </div>

            <div className="contact-email">
              <h3>{t('contact.form.title')}</h3>
              <p><strong>📧 {t('contact.email')}:</strong> <a href="mailto:info@molecorp.club">info@molecorp.club</a></p>
              <p>{t('contact.form.description')}</p>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="content-section" style={{ marginTop: '4rem' }}>
            <h2>{t('contact.faq.title')}</h2>
            
            <h3>{t('contact.faq.timeline.question')}</h3>
            <p>{t('contact.faq.timeline.answer')}</p>
            
            <h3>{t('contact.faq.support.question')}</h3>
            <p>{t('contact.faq.support.answer')}</p>
            
            <h3>{t('contact.faq.process.question')}</h3>
            <p>{t('contact.faq.process.answer')}</p>
            
            <h3>{t('contact.faq.international.question')}</h3>
            <p>{t('contact.faq.international.answer')}</p>
            
            <h3>{t('contact.faq.technologies.question')}</h3>
            <p>{t('contact.faq.technologies.answer')}</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;